<script>
    import Number from "./Number.svelte";
    import { handleCheckboxClick } from '../store.js';

    export let name
    export let id
    export let multiple
    export let instruction
    let aantal

    let isSelected = false;
    function toggleCheck(e) {
    handleCheckboxClick(name, e.target.checked, aantal = 1);       
    isSelected = !isSelected
    };
</script>
{#if instruction}

<label for={name} class:selected="{isSelected === true}">
    <input required type="checkbox" name={name} id={name} on:click={toggleCheck} >
    <span>{name}</span>
    {#if instruction}
    <p>{instruction}</p>
    {/if}
</label>

{:else}

<label for={name} class:selected="{isSelected === true}">
    <span>{name}</span>
    <input type="checkbox" name={name} id={name} on:click={toggleCheck} >
</label>
{#if multiple && isSelected}
<Number bind:aantal={aantal} name={name}></Number>

    {/if}
{/if}


<style>
    label {
        position: relative;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px;
        background: rgba(0,63,49,.1);
        border: 1px solid transparent;
        transition: all .3s ease-in;
        border-radius: 8px;
        margin-bottom: 10px;
    }

    label:hover {
        cursor: pointer;
        background-color: rgba(0,63,49,.08);

    }
    
    label.selected {
        background: white;
        border: 1px solid #CA1E22;
    }

    label span {
        font-size: 16px;
        font-weight: 700;
        font-family: 'Poppins',Helvetica,Arial,Lucida,sans-serif;
        color: #003f31;
    }
    input[type=checkbox] {
        appearance: none;
        position: relative;
        width: 20px;
        height: 20px;
        border-radius: 20px;
        background: transparent;
        border: 2px solid rgba(0,63,49,.1);
    }
    input[type=checkbox]::after {
        content: '';
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='9.763' height='6.716' viewBox='0 0 9.763 6.716'%3E%3Cpath id='Path_238' data-name='Path 238' d='M220.246,241.494l2.84,2.84,5.509-5.509' transform='translate(-219.539 -238.118)' fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='1'/%3E%3C/svg%3E%0A");
        position: absolute;
        width: 90%;
        height: 90%;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        opacity: 0;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: 50% 50%;
    }
    input[type=checkbox]:checked {
        background: #CA1E22;
        border: 2px solid #CA1E22;
    }

    input[type=checkbox]:checked::after {
        opacity: 1;
    }

</style>